import type { CSSProperties } from 'react';

export type SidebarNavStyleInput = {
  isActive: boolean;
  hasClientTheme: boolean;
  isAtlanticSidebarChrome: boolean;
};

export type NavIconVariant = 'primary' | 'neutral';
export type NavTileVariant = 'primary' | 'success' | 'none';

export const isAtlanticSidebarChromeTheme = (themeName?: string | null): boolean =>
  themeName === 'Atlantic Capital';

export const resolveNavIconVariant = ({ isActive }: SidebarNavStyleInput): NavIconVariant =>
  isActive ? 'primary' : 'neutral';

export const resolveActiveNavTileVariant = ({
  isActive,
  hasClientTheme,
  isAtlanticSidebarChrome,
}: SidebarNavStyleInput): NavTileVariant => {
  if (!isActive) return 'none';
  if (!hasClientTheme) return 'success';
  if (isAtlanticSidebarChrome) return 'none';
  return 'primary';
};

export const resolveActiveNavTileStyle = ({
  isActive,
  isAtlanticSidebarChrome,
}: SidebarNavStyleInput): CSSProperties | undefined =>
  isActive && isAtlanticSidebarChrome
    ? { backgroundColor: '#E8E8E8', borderRadius: '8px' }
    : undefined;

export const buildSidebarNavStyleInput = (
  isActive: boolean,
  clientTheme: { name: string } | null,
): SidebarNavStyleInput => ({
  isActive,
  hasClientTheme: !!clientTheme,
  isAtlanticSidebarChrome: isAtlanticSidebarChromeTheme(clientTheme?.name),
});
